import React, { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import { Auth } from 'aws-amplify';
import Loadingmini from '../components/loadingmini';
import { currentUserIsAdmin } from '../hooks/usePortalRole';

export default function AdminRoute({ children }) {
  const [state, setState] = useState({ loading: true, allowed: false });

  useEffect(() => {
    let mounted = true;
    (async () => {
      const allowed = await currentUserIsAdmin();
      if (mounted) {
        setState({ loading: false, allowed });
      }
    })();
    return () => {
      mounted = false;
    };
  }, []);

  if (state.loading) {
    return <Loadingmini />;
  }
  if (!state.allowed) {
    return <Navigate to="/" replace />;
  }
  return children;
}
